import { memo } from 'react';
import { View } from 'foundations-components/components/View';
import MessagePreview from '../../building-blocks/message-preview/MessagePreview';
import { formatDirectReplyData } from './formatDirectReplyData';
import { jsx as _jsx } from "react/jsx-runtime";
const DirectReplyOriginalMessagePreview = ({
  directReplyState,
  maxPreviewLength = 150
}) => {
  const {
    directReply,
    isFailed: isPreviewUnavailable,
    isLoading: isLoadingPreview,
    isMissingFileAttachment,
    resolvedFileAttachments,
    senderName,
    messageId
  } = directReplyState;
  const directReplyToData = directReply ? formatDirectReplyData({
    data: directReply,
    isMissingFileAttachment,
    resolvedFileAttachments,
    senderName
  }) : null;
  if (isLoadingPreview || isPreviewUnavailable) {
    return /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "100",
      children: /*#__PURE__*/_jsx(MessagePreview, {
        isLoading: isLoadingPreview,
        isPreviewable: false
      })
    });
  }
  return directReplyToData ? /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "100",
    children: /*#__PURE__*/_jsx(MessagePreview, Object.assign({
      isLoading: isLoadingPreview,
      isPreviewable: true,
      maxPreviewLength: maxPreviewLength,
      messageId: messageId
    }, directReplyToData))
  }) : null;
};
DirectReplyOriginalMessagePreview.displayName = 'DirectReplyOriginalMessagePreview';
export default /*#__PURE__*/memo(DirectReplyOriginalMessagePreview);